export function handlePeopleValueClick (event, paste) {
  if (event.ctrlKey || event.metaKey) return

  event.preventDefault()
  return paste()
}

export function handlePeopleCcClick (event, addRecipient) {
  return addRecipient(event.ctrlKey || event.metaKey ? 'bcc' : 'cc')
}

export function createPeopleActionRunner (onPending, onError) {
  const pending = new Set()

  return async (key, operation) => {
    if (pending.has(key)) return

    pending.add(key)
    onPending(new Set(pending))
    try {
      await operation()
    } catch (error) {
      console.error('People dialog action failed', {
        action: key,
        code: error?.code,
        message: error?.message,
        location: error?.debugInfo?.errorLocation
      })
      onError(error)
    } finally {
      pending.delete(key)
      onPending(new Set(pending))
    }
  }
}
